<ng-container *ngIf="entryTemplates$ | async as entryTemplates">
    <ng-container *ngIf="!disabled">
        <ng-container *ngIf="label && !hidden"><span>{{label}}</span>&nbsp;</ng-container>
        <p-dropdown [options]="entryTemplates" (onChange)="selectEntryTemplate($event)" [(ngModel)]="selectedEntryTemplate" [group]="true"
            appendTo="body" [disabled]="disabled" [hidden]="hidden"></p-dropdown>
    </ng-container>
</ng-container>